import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Collapse } from 'react-bootstrap';
import './DetailsInfo.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faAngleUp from '@fortawesome/fontawesome-free-solid/faAngleUp';

class DetailsInfo extends Component {
  static propTypes = {
    itemsLines: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object))
      .isRequired,
    itemsContainerSize: PropTypes.number,
    rightContainer: PropTypes.any,
    rightContainerSize: PropTypes.number,
  };

  static defaultProps = {
    itemsContainerSize: 8,
    rightContainerSize: 4,
  };

  constructor(props) {
    super(props);
    this.state = {
      showDetails: true,
    };
  }

  handleClickDetails = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      showDetails: !this.state.showDetails,
    });
  };

  render() {
    return (
      <div className="details-info">
        <div className="h4" onClick={this.handleClickDetails}>
          DETAILS{' '}
          <span>
            <FontAwesomeIcon
              icon={this.state.showDetails ? faAngleDown : faAngleUp}
            />
          </span>
        </div>

        <Collapse in={this.state.showDetails} className="collapse-info">
          <div>
            <Col md={this.props.itemsContainerSize} className="column">
              <div className="details-info-items">
                {this.props.itemsLines.map((itemLine, index) => {
                  return (
                    <div key={index}>
                      {itemLine.map((item, index) => {
                        return <div key={index}>{item}</div>;
                      })}
                    </div>
                  );
                })}
              </div>
            </Col>

            <Col md={this.props.rightContainerSize} className="column">
              {this.props.rightContainer}
            </Col>

            <div className="clearfix" />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default DetailsInfo;



// WEBPACK FOOTER //
// ./src/components/shared/details/DetailsInfo.js